import EntityModel from '@/common/models/entity-model';

export default class ListModel extends EntityModel {
    hydrate({
        id = null,
        description = null,
        version = null,
        values = [],
        createdTime = null,
        updatedTime = null,
    } = {}) {
        this.id = id;
        this.description = description;
        this.version = version;
        this.values = values;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
    }

    getPayload() {
        return {
            id: this.id,
            description: this.description,
            version: this.version,
            values: this.values,
            createdTime: this.createdTime,
            updatedTime: this.updatedTime,
        };
    }
}
